import { LocalStorage, SessionStorage } from '@hotjar/insights-common/lib/storage-factory';
/**
 * Wrapper for LocalStorage and SessionStorage.
 * Usage:
 * LocalStorage.get('foo')
 * LocalStorage.set('foo', {itAccepts: 'objects'})
 */
(function () {
    angular
        .module('hjApp.storage')
        .factory('LocalStorage', [() => LocalStorage])
        .factory('SessionStorage', [() => SessionStorage]);
})();
